import {Component, Input, OnInit} from '@angular/core';
import {Template} from "../../../../model/template";
import {AssetProperty} from "../../../../model/asset-property";
import {DeviceProperty} from "../../../../model/device-property";

@Component({
  selector: 'app-template-properties',
  templateUrl: './template-properties.component.html',
  styleUrls: ['./template-properties.component.scss']
})
export class TemplatePropertiesComponent implements OnInit {

  @Input()
  public template: Template;

  public properties: (AssetProperty | DeviceProperty)[];
  public totalProperties: number;
  public loadingProperties: boolean;

  public rows = 10;
  public first = 0;

  constructor() {
    this.properties = [];
  }

  ngOnInit(): void {
    this.loadProperties();
  }

  private loadProperties(): void {
    this.loadingProperties = true;
    if (this.template.type === 'DEVICE') {
      this.properties = this.template.content?.deviceProperties ? this.template.content.deviceProperties : [];
    } else {
      this.properties = this.template.content?.assetProperties ? this.template.content.assetProperties : [];
    }
    this.totalProperties = this.properties.length;
    this.loadingProperties = false;
  }

}
